import { render } from "./SkeletonItem.vue?vue&type=template&id=3a2a7f3a&ts=true"
import script from "./SkeletonItem.vue?vue&type=script&lang=ts"
export * from "./SkeletonItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
